module.exports = __webpack_public_path__ + "img/ic-exterieur.1b5dd1a0.svg";